module.exports = __webpack_public_path__ + "img/rmvcar.045507b4.webp";